import classNames from "classnames";
import vector from "Assets/vectors/triangle.svg";
import greenBall from "Assets/vectors/ball-green.svg";
import React from "react";
import styles from "Styles/CompanyNamePage/CompanyNameInfoContent.module.css";
import InfoContentMotionWrapper from "Components/MotionWrapper/InfoContentMotionWrapper";

const CompanyNameInfoContent = () => {
  const companyNameParagraphClassNames = classNames(
    styles.companyNameParagraph,
  );
  return (
    <>
      <InfoContentMotionWrapper>
        <img className={styles.greenBall} src={greenBall} alt="green ball" />
      </InfoContentMotionWrapper>
      <InfoContentMotionWrapper>
        <div>
          <p className={companyNameParagraphClassNames}>
            首先，你的公司名稱及產業？
          </p>
        </div>
      </InfoContentMotionWrapper>
      <InfoContentMotionWrapper>
        <img className={styles.vector} src={vector} alt="vector" />
      </InfoContentMotionWrapper>
    </>
  );
};

export default CompanyNameInfoContent;
